import axios from "axios";
import { API_URL } from "../../../setup/config/env";

export const saveQRCode = async (qrData, id = null) => {
    try {
        const url = id ? `${API_URL}/api/qr/${id}` : `${API_URL}/api/qr`;
        const response = await axios.post(url, qrData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error saving QR Code:", error);
        throw error;
    }
};

export const deleteQR = async(id)=>{
    try{
        const response = await axios.post(`${API_URL}/api/qr/${id}/delete`,{
            headers:{
                "Content-type":"application/json"
            }
        })
        return response.data
    }
    catch(error){
        console.error("Error deleting QR Code: ", error)
        throw error
    }
}